export var ETokenType;
(function (ETokenType) {
    ETokenType["Refresh"] = "refresh";
    ETokenType["Guest"] = "guest";
})(ETokenType || (ETokenType = {}));
//# sourceMappingURL=token.js.map